/** Colors and sizes taken from docs/reference/mockup.jpg. Both apps use these. */
export const colors = {
  background: '#F6F2EC',
  card: '#FFFFFF',
  cardBorder: '#ECE6DC',
  primary: '#4D6E5C',
  primaryDark: '#3E5B4B',
  primarySoft: '#E4ECE5',
  primaryMuted: '#9DB3A5',
  text: '#2B3530',
  /** Secondary text. Darkened per the brand guide so small text is readable (4.5 to 1). */
  textMuted: '#68716C',
  /** Decoration only (lines, empty boxes). Never for words: too pale to read. */
  textFaint: '#A9AFAA',
  danger: '#D9534A',
  dangerSoft: '#FBE4E1',
  warning: '#E8A33D',
  warningSoft: '#FCEFD9',
  alertBanner: '#FBE7DC',
  ok: '#4F8A62',
  /** Darker versions for the rare colored word; the bright ones are for dots and icons only. */
  dangerText: '#B8403A',
  warningText: '#8A5A0B',
  okText: '#3F7551',
  divider: '#EFEAE2',
  white: '#FFFFFF',
} as const;

export const radius = { card: 16, button: 28, chip: 14 } as const;

export const fonts = {
  /** The serif used for the name in the logo: Lora (decision 63). */
  logo: 'Lora_500Medium',
  /** The handwritten line: the tagline and the thank-you to staff (brand guide section 5). */
  hand: 'Caveat_500Medium',
  regular: 'Inter_400Regular',
  medium: 'Inter_500Medium',
  semibold: 'Inter_600SemiBold',
} as const;
